import {Injectable} from '@angular/core';
import {HttpService} from '../../shared/services/http.service';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {BaseResponse} from '../../shared/models/respose/BaseResponse';
import {ContactType} from '../../shared/models/ContactType';
import {Order} from '../../shared/models/Order';
import {PaginatedDataResponse} from '../../shared/models/respose/PaginatedDataResponse';
import {PaginatedDataRequest} from '../../shared/models/request/PaginatedDataRequest';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ContactTypeService extends HttpService {



  getAll(): Observable<BaseResponse<ContactType[]>>{
    return this.get('contact_types');
  }

  getPaginatedList(entries: number,
                   page: number,
                   data?: ContactType,
                   order?: Order): Observable<BaseResponse<PaginatedDataResponse<ContactType>>>{
    const request = new PaginatedDataRequest<ContactType>(entries, page, data, order);
    return this.post('contact_types', request).pipe(
      map(response => {
        return response;
      })
    );
  }

  register(request: ContactType): Observable<BaseResponse<ContactType>>{
    return this.post('contact_types/store', request);
  }

  deleteItem(id: number): Observable<BaseResponse<ContactType>>{
    return this.delete('contact_types', id);
  }

  updateItem(request: ContactType, id: number): Observable<BaseResponse<ContactType>>{
    return this.put('contact_types', request, id);
  }
}
